import { forwardRef, useState } from 'react'
import { useSelector } from 'src/redux/store'
import { IMaskInput } from 'react-imask'
import { Button, Grid, TextField, Typography, styled, Card, Link } from '@mui/material'
import { Box } from '@mui/system'
import { validateCNPJ } from '../../../utils/common'
import { LoadingButton } from '@mui/lab'

const CommonCard = styled(Card)(({ theme }) => ({
  boxShadow: theme.customShadows.zCard,
  borderRadius: theme.spacing(2),
  padding: theme.spacing(3),
  backgroundColor: 'transparent',
}))

const CepMask = forwardRef(function CepMask(props, ref) {
  const { onChange, ...other } = props
  return (
    <IMaskInput
      {...other}
      mask="00000-000"
      inputRef={ref}
      onAccept={value => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  )
})

const CPFMask = forwardRef(function CPFMask(props, ref) {
  const { onChange, ...other } = props

  return (
    <IMaskInput
      {...other}
      mask={props.value.length > 14 ? "00.000.000/0000-00" : "000.000.000-000"}
      inputRef={ref}
      onAccept={value => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  )
})

const PhoneMask = forwardRef(function PhoneMask(props, ref) {
  const { onChange, ...other } = props

  return (
    <IMaskInput
      {...other}
      mask={props.value.length > 14 ?  "(00) 00000-0000" : "(00) 0000-00000"}
      inputRef={ref}
      onAccept={value => onChange({ target: { name: props.name, value } })}
      overwrite
    />
  )
})

export default function PaymentBoleto({ onSubmit, isLoadingButton, disabledButton }) {
  const [data, setData] = useState(null)
  const [error, setError] = useState(null)

  const handleSubmit = () => {
    let errObj = null

    if (!data?.cpf) {
      errObj = {
        ...errObj,
        cpf: `CNPJ é obrigatório!`,
      }
    } else if (data?.cpf.length === 14) {
      errObj = {
        ...errObj,
        cpf: `Para cobranças destinadas a Pessoa Física, por favor, entre em contato!`,
      }
    } else {
      if (data?.cpf.length !== 18) {
        // if (!validateCPF(data.cpf)) {
          errObj = {
            ...errObj,
            cpf: `Formato do cnpj inválido!`,
          }
        // }
      } else {
        if (!validateCNPJ(data?.cpf)) {
          errObj = {
            ...errObj,
            cpf: `CNPJ inválido!`,
          }
        }
      }
    }
    if(!data?.phone) {
      errObj = {
        ...errObj,
        phone: `Telefone é obrigatório!`,
      }
    } else if (data?.phone?.length < 14) {
      errObj = {
        ...errObj,
        phone: `Formato de telefone inválido!`,
      }
    }

    if (!data?.cep) {
      errObj = {
        ...errObj,
        cep: `CEP é obrigatório!`,
      }
    } else if (data?.cep?.length !== 9) {
      errObj = {
        ...errObj,
        cep: `Formato de CEP inválido!`,
      }
    }

    if (!data?.address) {
      errObj = {
        ...errObj,
        address: `Endereço é obrigatório!`,
      }
    }

    if (!data?.number) {
      errObj = {
        ...errObj,
        number: `Número é obrigatório!`,
      }
    }

    if (!data?.bairro) {
      errObj = {
        ...errObj,
        bairro: `Bairro é obrigatório!`,
      }
    }

    if (!data?.cidade) {
      errObj = {
        ...errObj,
        cidade: `Cidade / Estado é obrigatório!`,
      }
    }

    if (errObj) {
      setError(errObj)
      return
    }
    onSubmit(data)
  }

  const updateData = (key, val) => {
    setError(null)
    const updated = { ...data }
    updated[key] = val
    setData(updated)
  }

  const getInfosCEP = async (i) => {
    var cep = data?.cep.replace(/\D/g, '');
    var result = await fetch('https://viacep.com.br/ws/' + cep + '/json');
    result = await result.json()
    if (result.erro) {
      setError({
        cep: 'CEP inválido, por favor digite outro!'
      })
    } else {
      const updated = { ...data }
      updated.cidade = result.localidade + '/' + result.uf
      updated.address = result.logradouro
      updated.bairro = result.bairro
      setData(updated)
    }
  }

  return (
    <CommonCard>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
        <Typography>
          Para cobranças destinadas a Pessoa Física, por favor, entre em contato <Link target='_blank' href='http://wa.me/+555195272351'>clicando aqui</Link>
        </Typography>
        <TextField
          label="CNPJ do Titular *"
          variant="outlined"
          fullWidth
          value={data?.cpf || ''}
          InputProps={{ inputComponent: CPFMask }}
          onChange={e => updateData('cpf', e.target.value)}
          error={error?.cpf ? true : false}
          helperText={error?.cpf || ''}
        />

        <TextField
          label="Telefone do Titular *"
          variant="outlined"
          fullWidth
          value={data?.phone || ''}
          InputProps={{ inputComponent: PhoneMask }}
          onChange={e => updateData('phone', e.target.value)}
          error={error?.phone ? true : false}
          helperText={error?.phone || ''}
        />

        <Typography variant="subtitle2" color="text.secondary">
          Endereço de Cobrança
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="CEP *"
              variant="outlined"
              fullWidth
              value={data?.cep || ''}
              onChange={e => updateData('cep', e.target.value)}
              InputProps={{ inputComponent: CepMask }}
              error={error?.cep ? true : false}
              helperText={error?.cep || ''}
            />
          </Grid>
          <Grid item xs={6} sx={{ display: 'flex', alignItems: 'center' }}>
            <Button variant="text" disabled={!(data?.cep) || data?.cep.length < 9} onClick={() => getInfosCEP()}>Buscar</Button>
          </Grid>
        </Grid>
        <TextField
          label="Endereço *"
          variant="outlined"
          fullWidth
          value={data?.address || ''}
          onChange={e => updateData('address', e.target.value)}
          error={error?.address ? true : false}
          helperText={error?.address || ''}
        />
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Número *"
              variant="outlined"
              type="number"
              fullWidth
              value={data?.number || ''}
              onChange={e => updateData('number', e.target.value)}
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
              error={error?.number ? true : false}
              helperText={error?.number || ''}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Complemento"
              variant="outlined"
              fullWidth
              value={data?.complemento || ''}
              onChange={e => updateData('complemento', e.target.value)}
            />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              label="Bairro *"
              variant="outlined"
              fullWidth
              value={data?.bairro || ''}
              onChange={e => updateData('bairro', e.target.value)}
              error={error?.bairro ? true : false}
              helperText={error?.bairro || ''}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              label="Cidade / Estado *"
              variant="outlined"
              fullWidth
              value={data?.cidade || ''}
              onChange={e => updateData('cidade', e.target.value)}
              error={error?.cidade ? true : false}
              helperText={error?.cidade || ''}
            />
          </Grid>
        </Grid>
        <Box display={'flex'} justifyContent={"center"}>
          <LoadingButton disabled={disabledButton} loading={isLoadingButton} size='medium' variant="contained" onClick={handleSubmit} >
            Gerar Cobrança
          </LoadingButton>
        </Box>
      </Box>
    </CommonCard>
  )
}
